module.exports = __webpack_public_path__ + "img/studentinterestsdg.d845eac5.png";